var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrivacy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19806"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19796"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0A20 20 0 1 1 0 20 20 20 0 0 1 20 0",
  "data-name": "Path 27401"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19768"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.233 18.705v-1.976a1.975 1.975 0 0 1 1.976-1.976h1.584a1.975 1.975 0 0 1 1.976 1.976v1.976h-6.326v3.161a1.58 1.58 0 0 0 1.581 1.581h3.952a1.58 1.58 0 0 0 1.581-1.581V18.72l-.79-.015",
  "data-name": "Path 27418"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.307 17.439v-2.706a2.76 2.76 0 0 1 1.95-2.638l5.51-1.7a4.2 4.2 0 0 1 2.476 0l5.51 1.7a2.76 2.76 0 0 1 1.945 2.637v2.706c0 5.747-1.4 9.068-7.465 12.07a2.77 2.77 0 0 1-2.458 0c-6.072-3.001-7.468-6.322-7.468-12.069",
  "data-name": "Path 27419"
}))))));
export { SvgPrivacy as ReactComponent };
export default __webpack_public_path__ + "static/media/privacy.8e966b9cdc5af1fe85b3819b7cd4a0e8.svg";